<div class="pt-4 pb-6 flex flex-col gap-6">
  <zaeper-input-group [inputOptions]="scheduleReceiverConfigPushInputGroup"></zaeper-input-group>
</div>
<div class="w-full flex gap-2 justify-end">
  <p-button (onClick)="close()" [rounded]="true" [outlined]="true">Abrechen</p-button>
  <p-button (onClick)="submit()" [rounded]="true">Planen</p-button>
</div>
